import React from 'react';
import PropTypes from 'prop-types';
import getNavLink from './nav-links';

const NavbarLink = ({ label, badge, link }) => {
  const itemLink = link || getNavLink(label);
  return (
    <li className="nav-item">
      <a href={itemLink} className="nav-link">
        {label}
        {'  '}
        {badge && <span className="badge badge-default">{badge.toUpperCase()}</span>}
      </a>
    </li>
  );
};

NavbarLink.defaultProps = {
  badge: undefined,
  link: undefined
};

NavbarLink.propTypes = {
  label: PropTypes.string.isRequired,
  badge: PropTypes.string,
  link: PropTypes.string
};

export default NavbarLink;
